import client from "./client";

export const fxSettings = async () => (await client.get("/fx/settings")).data;
export const saveFxAnchor = async (rate, note) => (await client.put("/fx/settings", { rate, note })).data;
export const fxAuditLog = async () => (await client.get("/fx/audit-log")).data;
export const fxConvert = async (body) => (await client.post("/fx/convert", body)).data;
